import { Injectable } from '@angular/core';
import { ApiService } from '../api/bff-prompts';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PerfilPromptService {
  constructor(private apiService: ApiService) {}

  editUserAvatar(user: string, body: FormData) {
    const url = `usuario/foto`;
    return this.apiService.post<any>(url, body);
  }

  //edição de dados do usuário
  editUserFrase(usuarioLogin: string, frase: string) {
    const url = `usuario/`;
    const body = {
    //usuario_id: userId,
      usuario_login: usuarioLogin,
      usuario_frase: frase,
    };
    return this.apiService.post<any>(url, body);
  }

  editUserApelido(usuarioLogin: string, apelido: string) {
    const url = `usuario/`;
    const body = {
    //usuario_id: userId,
      usuario_login: usuarioLogin,
      usuario_apelido: apelido,
    };
    return this.apiService.post<any>(url, body);
  }

  editUserEmail(usuarioLogin: string, email: string) {
    const url = `usuario/`;
    const body = {
   // usuario_id: userId,
      usuario_login: usuarioLogin,
      usuario_email: email,
    };
    return this.apiService.post<any>(url, body);
  }

  editUser(usuarioLogin: string, email: string, apelido: string, frase: string) {
    const url = `usuario/`;
    const body = {
      //usuario_id: userId,
      usuario_cessaodireitos: false,
      usuario_login: usuarioLogin,
      usuario_apelido: apelido,
      usuario_frase: frase,
      usuario_email: email,
    };
    return this.apiService.post<any>(url, body);
  }

  getUserData(usuarioLogin: string): Observable<any> {
    const endpoint = `usuario/?login=${usuarioLogin}`;
    return this.apiService.get<any>(endpoint);
  }
}
